import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router';

import { getTeacherView } from '../../Common/Database';
import EditTeacherModal from '../../Components/EditTeacherModal';
import Loader from '../../Components/Loader';
import Tooltipe from '../../Components/Tooltipe';
import { getUserType } from '../../redux/slices/userSlice';

import '../StudentView/style.scss';
import './style.scss';

const TeacherView = ({ mail }) => {
  const { t } = useTranslation();
  const params = useParams();
  const userTypeSelector = useSelector(getUserType);

  const [teacher, setTeacher] = useState();
  const [subjectList, setSubjectList] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [addSubject, setAddSubject] = useState();
  const [openModal, setOpenModal] = useState(false);
  const [editTeacher, setEditTeacher] = useState(true);
  const [userType, setUserType] = useState(userTypeSelector);

  const fetchTeacherView = async () => {
    await getTeacherView(params.id).then(response => {
      const resp = response.val();
      let teachSubjects = Object.values(resp.subjects);

      setTeacher(resp);
      setSubjectList(teachSubjects);
      setIsLoading(false);
    });
  };

  const openModalUpdateTeacher = async () => {
    setOpenModal(true);
    await getTeacherView(params.id).then(response => {
      const resp = response.val();
      setTeacher(resp);
      setIsLoading(false);
    });
  };

  useEffect(() => {
    setUserType(userTypeSelector);
    fetchTeacherView();
  }, [addSubject, userTypeSelector, userType]);

  return (
    <div className="student-view-page teacher-view-page container">
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <div className="list-wrap teacher-wrap">
            <h2>
              {t('teachers data')}:{' '}
              <Tooltipe method={openModalUpdateTeacher} text="update" icon="icon-edit-1" btnClass="move-view" />
            </h2>
            <ul className="teacher-data-list">
              <li>
                <span className="key">{t('fio teacher')}: </span>
                <span className="value">{teacher.FIO}</span>
              </li>
              <li>
                <span className="key">{t('email')}: </span>
                <span className="value">{teacher.email}</span>
              </li>
              <li>
                <span className="key">{t('phoneNumber')}: </span>
                <span className="value">{teacher.phone ? teacher.phone : '-'}</span>
              </li>
              <li>
                <span className="key">{t('city')}: </span>
                <span className="value">{teacher.city ? teacher.city : '-'}</span>
              </li>
              <li>
                <span className="key">{t('branch')}: </span>
                <span className="value">{teacher.branch ? teacher.branch : '-'}</span>
              </li>
            </ul>
          </div>

          {openModal && (
            <EditTeacherModal
              open={openModal}
              setOpen={setOpenModal}
              submit={t('update')}
              nameAction={'createForm'}
              updateFormObj={''}
              teacher={teacher}
              editTeacher={editTeacher}
              fetchTeacherView={fetchTeacherView}
            />
          )}
        </>
      )}
    </div>
  );
};

export default TeacherView;
